export default [
    {
        path: 'cp',
        name: 'SpSiteCp',
        component: () => import('@/views/spsite/cp/index')
    },
    {
        path: 'sp',
        name: 'SpSiteSp',
        component: () => import('@/views/spsite/sp/index')
    },
    {
        path: 'spapp',
        name: 'SpSiteSpApp',
        component: () => import('@/views/spsite/spapp/index')
    },
    {
        path: 'spapp/:link_id',
        props: true,
        name: 'SpSiteSpAppOne',
        component: () => import('@/views/spsite/spapp/index')
    },
    {
        path: 'cpapp',
        name: 'SpSiteCpApp',
        component: () => import('@/views/spsite/cpapp/index')
    },
    {
        path: 'cpapp/:app_id',
        props: true,
        name: 'SpSiteCpAppOne',
        component: () => import('@/views/spsite/cpapp/index')
    },
    {
        path: 'tpl',
        name: 'SpSiteTpl',
        component: () => import('@/views/spsite/tpl/index')
    },
    {
        path: 'cppack',
        name: 'SpSiteCpPack',
        component: () => import('@/views/spsite/cppack/index')
    },
    {
        path: 'trx/detail',
        name: 'SpSiteTrxDetailRead',
        component: () => import('@/views/spsite/trx/detail/index')
    },
    {
        path: 'trx/summary',
        name: 'SpSiteTrxSummaryRead',
        component: () => import('@/views/spsite/trx/summary/index')
    },
    {
        path: 'smppnode',
        name: 'SpSiteSmppNode',
        component: () => import('@/views/spsite/smppnode/index')
    },
    {
        path: 'test',
        name: 'SpSiteTest',
        component: () => import('@/views/spsite/trxt/Index')
    }
];